import { KeycloakService } from 'keycloak-angular';
import { KeycloakConfig } from './keycloak-config';
import { Helpers } from '../helpers';

export function KeycloakInitializer(keycloak: KeycloakService): () => Promise<any> {
    return (): Promise<any> => {
        return new Promise(async (resolve, reject) => {
            try {
                await keycloak.init({
                    config: {

                        url: KeycloakConfig._authUrl,
                        realm: KeycloakConfig._realm,
                        clientId: KeycloakConfig._clientId
                    },
                    initOptions: {
                        onLoad: 'login-required',
                        checkLoginIframe: false,

                    },

                    // bearerExcludedUrls: ['http://192.168.27.88:8080/dashboard'],
                    // enableBearerInterceptor: true,
                    // bearerPrefix: 'Bearer',

                    // bearerExcludedUrls: ['https://proximity-api.guglielmo.dev']
                    // enableBearerInterceptor: true,
                    // bearerPrefix: 'Bearer',
                    // bearerExcludedUrls: ['https://proximity-api.guglielmo.dev']
                });

                const subject = keycloak["_instance"]["subject"];
                const exp = keycloak["_instance"]["tokenParsed"]["exp"]
                const d = new Date(exp * 1000);
                const expires = d.getTime();
                const token = keycloak["_instance"]["token"];
                const idToken = keycloak["_instance"]["idToken"];
                const previousCurrentUser = Helpers.getCurrentUser();

                if (await keycloak.isLoggedIn()) {
                    const currentUser = {
                        "authorization": "Bearer",
                        "duration": "7200s",
                        "expires": expires,
                        "status": true,
                        "token": token,
                        "idToken": idToken,
                        "consumer_name": subject,
                        "credential_username": subject,
                        "role": keycloak["_instance"]["realmAccess"]["roles"][0]
                    };
                    const shouldResetDashboardState =
                        !previousCurrentUser ||
                        previousCurrentUser.consumer_name !== subject;

                    localStorage.setItem('currentUser', JSON.stringify(currentUser));

                    if (shouldResetDashboardState) {
                        Helpers.cleanAllStorageDataExist();
                        localStorage.setItem('currentUser', JSON.stringify(currentUser));
                    }
                } else {
                    window.location.href = KeycloakConfig._baseUrl;
                }
                resolve(null);

            } catch (error) {
                console.error("ERROR during access from Keycloak");
                window.location.href = KeycloakConfig._baseUrl;
                reject(error);
            }
        });
    };



}
